import { StreamActions } from "@hotwired/turbo";
import Notify from "simple-notify";

StreamActions.flash = function () {
  const notify = new Notify({
    customClass:
      this.getAttribute("klass") === "success"
        ? "custom-success"
        : "custom-notify",
    status: this.getAttribute("klass"),
    title: this.getAttribute("text"),
    effect: "fade",
    speed: parseInt(this.getAttribute("speed")) || 500,
    showCloseButton: true,
    autoclose: true,
    position: "right bottom",
  });

  return notify;
};

StreamActions.flash_redirect = function () {
  const text = this.getAttribute("text");
  const klass = this.getAttribute("klass");
  const path = this.getAttribute("path");
  sessionStorage.setItem("pending_flash", JSON.stringify({ text, klass }));
  Turbo.visit(path);
};

document.addEventListener("turbo:load", () => {
  const pending = sessionStorage.getItem("pending_flash");
  if (pending) {
    sessionStorage.removeItem("pending_flash");
    const { text, klass } = JSON.parse(pending);
    new Notify({
      customClass: klass === "success" ? "custom-success" : "custom-notify",
      status: klass,
      title: text,
      effect: "fade",
      speed: 500,
      showCloseButton: true,
      autoclose: true,
      position: "right bottom",
    });
  }
});

StreamActions.hide_modal_form = () => {
  // window.currentModalForm.hide()
  document.querySelectorAll("#modal_form").forEach((element) => {
    element.replaceChildren();
  });
};

StreamActions.remove_with_animation = function () {
  const target = this.getAttribute("target");
  const animationClass = this.getAttribute("animation");
  // animateCss default anim duration is 1sec
  const removeDelay = this.getAttribute("remove_delay");
  const element = document.getElementById(target);
  element.classList.add("animate__animated", animationClass);
  setTimeout(() => {
    element.remove();
  }, removeDelay);
};

StreamActions.remove_elements_with_animation = function () {
  const elements = document.querySelectorAll(this.getAttribute("targets"));
  const animationClass = this.getAttribute("animation");
  // animateCss default anim duration is 1sec
  const removeDelay = this.getAttribute("remove_delay");
  elements.forEach((element) => {
    element.classList.add("animate__animated", animationClass);
    setTimeout(() => {
      element.remove();
    }, removeDelay);
  });
};

StreamActions.reinitialize_styles = function () {
  // Forcer la réinitialisation des styles CSS pour les éléments nouvellement ajoutés
  setTimeout(() => {
    // Réinitialiser les contrôleurs Stimulus si nécessaire
    const event = new CustomEvent("turbo:load");
    document.dispatchEvent(event);

    // Forcer la réinitialisation des styles pour les éléments dans saved_searches_list
    const savedSearchesList = document.getElementById("saved_searches_list");
    if (savedSearchesList) {
      const newElements = savedSearchesList.querySelectorAll(
        ".flex.flex-col.mb-4:not([data-styles-applied])",
      );
      newElements.forEach((element) => {
        // Marquer comme styles appliqués pour éviter les doublons
        element.setAttribute("data-styles-applied", "true");

        // Forcer le recalcul des styles
        element.style.display = "none";
        element.offsetHeight; // Trigger reflow
        element.style.display = "";
      });
    }
  }, 100);
};

StreamActions.increase_modal_z_index = function () {
  const modals = document.querySelectorAll(".hs-overlay");
  let maxZ = 80;

  modals.forEach(function (modal) {
    const z = parseInt(
      modal.style.zIndex || window.getComputedStyle(modal).zIndex || "80",
    );
    if (z > maxZ) maxZ = z;
  });

  const modalForm = document.querySelector("#modal_form");
  if (modalForm) {
    const parent = modalForm.closest(".hs-overlay");
    if (parent) {
      parent.style.zIndex = (maxZ + 10).toString();
    }
  }
};
